import {
  Component,
  OnInit,
  ViewChildren,
  ViewChild,
  QueryList,
  HostListener,
  ChangeDetectorRef,
  AfterViewInit,
  ElementRef
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { JournalService } from '@journal/core/api/journal/journal.service';
import { UserService } from '@sparro/app/core/api/user/user.service';
import { ImageOptimizerService } from '@sparro/app/core/helpers/image-optimizer';
import { UniApiConfig } from '@sparro/app/core/config/api.config';
import { CompetitionService } from '@journal/core/api/competition/competition.service';
import { MetaService } from '@sparro/app/core/helpers/meta/meta.service';
import { MetaDefinition } from '@angular/platform-browser';
import { ToastrService } from '@sparro/app/core/helpers/toastr/toastr.service';
import { FollowerService } from '@sparro/app/core/api/follower/follower.service';
import { AuthService } from '@journal/app/core/api/auth/auth.service';
import { Blog } from '@sparro/app/core/models/blog.model';
import { User } from '@sparro/app/core/models/user.model';
import { environment } from '@journal/env/environment';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Competition } from '@sparro/app/core/models/competition.model';
import { BREAKPOINTS } from '@sparro/app/core/config/constants.config';
import { MatDrawer } from '@angular/material/sidenav';
import { NeoAdvertisement } from '@sparro/app/core/models/ads.model';
import _ from 'lodash';
import { HeaderService } from '@sparro/app/core/api/header/header.service';
export class ShowFloatingShare {
  horizontally: boolean;
  vertically: boolean;
}

export class IsFollowing {
  id: number;
  follower: number;
}
@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class DetailComponent implements OnInit, AfterViewInit {
  blog: Blog;
  link: string;
  user: User;
  featuredCompetition: Competition = null;
  isLoading: boolean = false;
  source: string = '';
  mobileView: boolean = false;
  desktopView: boolean = false;
  blogCopyLink: string;
  self: boolean = false;
  similarBlogs: Blog[] = [];
  similarCompetitions: Competition[] = [];
  blogsCount: number = 4;
  minCompetitionCount: number = 5;
  sharedContent: object = {};
  commentSectionTop: number;
  showFloatingShare: ShowFloatingShare = {
    horizontally: true,
    vertically: true
  };
  trendingArticles: Blog[] = [];
  titleAppearance: boolean = false;
  advertisement: NeoAdvertisement = null;
  host: string = 'Journal';
  competitionUrl: string = environment.competitionUrl;
  metaSectionTop: number;
  articleSchema: { [key: string]: any };
  leftSideNav: boolean = false;
  membershipPageUrl: string = `${environment.serverUrl}about/designers/membership`;
  authPageUrl: string = ``;

  @ViewChild('leftnav') leftnav: MatDrawer;
  @ViewChild('sidenav') sidenav: ElementRef;
  @ViewChildren('commentSection') commentSection: QueryList<any>;

  constructor(
    public route: ActivatedRoute,
    private authService: AuthService,
    public router: Router,
    public metaService: MetaService,
    private blogService: JournalService,
    private userService: UserService,
    private headerService: HeaderService,
    private competitionService: CompetitionService,
    private imageOptimization: ImageOptimizerService,
    public toast: ToastrService,
    public dialog: MatDialog,
    private _apiConfig: UniApiConfig,
    public breakpointObserver: BreakpointObserver,
    private followerService: FollowerService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.authPageUrl = `${environment.loginUrl}/authentication?service=sign-in&continue=${window.location.href}`;
    this.getAdvertisement();
    this.headerService.getLeftNav().subscribe(res => {
      this.leftSideNav = res;
    });
    this.initializeBreakpoints();
    this.source = this._apiConfig.blogUrl;
    this.blogCopyLink = this._apiConfig.copyLinkUrls.blogUrl;
    this.getBlogDetail(this.route.snapshot.params.slug);
    this.getAuthUser();
    this.getFeaturedCompetition();
    this.getTrendingArticles();
  }

  getTrendingArticles() {
    this.blogService.getTrendingBlogs().subscribe(
      (response: Blog[]) => {
        this.trendingArticles = response;
      },
      err => {
        console.log(err);
      }
    );
  }

  getFeaturedCompetition() {
    this.blogService.getBlogTypeCompetitions().subscribe((response: any) => {
      if (response?.results?.length) {
        this.featuredCompetition = response.results[0];
      }
    });
  }

  ngAfterViewInit(): void {
    this.onWindowScroll();
  }

  getAdvertisement() {
    this.blogService.getAd(this.host).subscribe(
      (res: any) => {
        this.advertisement = res[_.random(0, res.length - 1)];
      },
      err => {
        console.log(err);
      }
    );
  }

  getCommentSectionDetail() {
    this.commentSection.changes.subscribe(() => {
      this.commentSectionTop = this.commentSection.first.nativeElement.offsetTop;
    });
  }

  initializeBreakpoints() {
    this.breakpointObserver
      .observe([
        BREAKPOINTS.below.md,
        BREAKPOINTS.below.lg,
        BREAKPOINTS.above.lg,
        BREAKPOINTS.below.xl,
        BREAKPOINTS.below.sm
      ])
      .subscribe(result => {
        if (result.breakpoints[BREAKPOINTS.below.md] != this.mobileView) {
          this.mobileView = !this.mobileView;
        }
        if (result.breakpoints[BREAKPOINTS.below.sm]) {
          this.minCompetitionCount = 1;
        } else if (result.breakpoints[BREAKPOINTS.below.lg]) {
          this.minCompetitionCount = 2;
        } else if (result.breakpoints[BREAKPOINTS.below.xl]) {
          this.minCompetitionCount = 3;
        } else {
          this.minCompetitionCount = 4;
        }
        this.showFloatingShare.horizontally = !Boolean(result.breakpoints[BREAKPOINTS.below.lg]);
      });
  }

  getBlogDetail(slug: string) {
    this.isLoading = true;
    this.blogService.getBlogDetail(slug).subscribe(
      (response: Blog) => {
        this.blog = response;
        this.articleSchema = this.metaService.createArticleSchema(this.blog);
        this.updateSharedContent();
        if (this.blog.author.username == this.user?.username) {
          this.self = true;
        }
        this.getSimilar();
        this.getCommentSectionDetail();
        this.isLoading = false;
        this.updateMetaInfo(this.blog);
        this.link = `${environment.postUrl}${this.blog.slug}/`;
      },
      err => {
        console.log(err);
        this.router.navigate(['error'], {
          queryParams: { code: '404' }
        });
      }
    );
  }

  updateSharedContent() {
    this.sharedContent = {
      title: this.blog.title,
      subtitle: this.blog.tagline,
      cover_image: this.blog.image
    };
  }

  getSimilar() {
    this.blogService.similarBlogs(this.blog.slug).subscribe((response: any) => {
      this.similarBlogs = response;
    });

    let disciplineIds: number[] = [];
    this.blog.disciplines.forEach(discipline => {
      disciplineIds.push(discipline.id);
    });

    this.competitionService
      .getFilteredResults(disciplineIds.toString())
      .subscribe((response: any) => {
        response.results.forEach((competition: Competition) => {
          if (
            competition.registration_deadline != 'Closed' &&
            competition.submission_deadline != 'Closed'
          )
            this.similarCompetitions.push(competition);
        });
      });
  }

  loadMore(event: boolean) {
    if (event) {
      this.blogsCount += 4;
    } else {
      this.blogsCount = 4;
    }
  }

  setMetaPosition(position: number) {
    this.metaSectionTop = position;
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.showFloatingShare.vertically = Boolean(window.pageYOffset < this.commentSectionTop);
    this.titleAppearance =
      window.pageYOffset >= this.metaSectionTop - 300 && this.showFloatingShare.vertically;
    if (this.titleAppearance && this.blog) {
      this.headerService.setHeaderTitle(this.blog.title);
    } else {
      this.headerService.setHeaderTitle('');
    }
    if (this.sidenav) {
      this.sidenav.nativeElement.style.top = `-${
        this.sidenav.nativeElement.offsetHeight + 10 - window.innerHeight
      }px`;
    }
  }

  updateMetaInfo(blog: Blog) {
    let metaInfo: MetaDefinition[] = [];
    let title: string, cover: string, content: string;
    let published_time = new Date(blog.created_at);
    title = `${blog.title} | ${blog.disciplines[0].name} ${blog.type.name}`;
    cover = blog.image ? this.renderImage(blog.image) : '';
    content = blog.tagline;

    metaInfo = [
      { name: 'title', content: title },
      { name: 'description', content: content },
      { name: 'url', content: window.location.href },
      { name: 'image', content: cover },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: blog.title },
      { name: 'twitter:description', content: content },
      { name: 'twitter:url', content: window.location.href },
      { name: 'twitter:image', content: cover },
      { property: 'og:title', content: blog.title },
      { property: 'og:description', content: content },
      { property: 'og:url', content: window.location.href },
      { property: 'og:image', content: cover },
      { property: 'og:image:alt', content: blog.title },
      { property: 'og:type', content: 'article' },
      { property: 'article:published_time', content: published_time.toUTCString() },
      { property: 'article:author', content: `${blog.author.first_name} ${blog.author.last_name}` },
      {
        property: 'article:section',
        content: `${blog.disciplines ? blog.disciplines.map(d => d.name) : ''}`
      },
      { property: 'article:tag', content: `${blog.tags ? blog.tags.map(t => t.name) : ''}` }
    ];
    metaInfo.forEach(meta => {
      this.metaService.updateMetaInfo(meta);
    });
    this.metaService.updateMeta(metaInfo);
    this.metaService.updateTitle(title);
    this.metaService.createCanonicalURL();
  }

  getAuthUser() {
    this.userService.userInitialized.subscribe((initialized: boolean) => {
      if (initialized) {
        this.userService.user.subscribe((response: User) => {
          this.user = response;
        });
      }
    });
  }

  renderImage(image: string) {
    return this.imageOptimization.renderImage(image, window.innerWidth, '');
  }

  goBack() {
    this.router.navigate([''], { relativeTo: this.route });
  }

  counter(event: number) {
    if (event) {
      this.blog.comments += 1;
    }
  }

  toggleUserFollow() {
    if (this.blog.author.is_following) {
      this.followerService
        .unfollow('users', this.blog.author.username, this.blog.author.is_following?.id)
        .subscribe((response: IsFollowing) => {
          if (response) {
            this.blog.author.is_following = null;
            this.changeDetectorRef.detectChanges();
          }
        });
    } else {
      const data = {
        follower: this.user.id
      };
      this.followerService.follow('users', this.blog.author.username, data).subscribe(
        (response: IsFollowing) => {
          this.changeDetectorRef.detectChanges();
          this.blog.author.is_following = response;
        },
        err => {
          console.log(err);
        }
      );
    }
  }

  getCompetitionFeedUrl() {
    return `${environment.competitionUrl}`;
  }

  getJournalFeedUrl() {
    return `${environment.postUrl}`;
  }

  getProfileUrl(blog: Blog): string {
    const url = `${environment.profileUrl}${blog.author.username}/`;
    return url;
  }

  closeBackdrop(): void {
    this.headerService.setLeftNav(false);
    this.leftnav.toggle();
  }
}
